import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUtmTracking } from '../../hooks/useUtmTracking';
import { captureAttribution } from '../../services/attribution/attribution';

// Captura la atribución en cualquier ruta del sitio, no solo en las páginas
// que llaman useUtmTracking por su cuenta.
const AttributionTracker = () => {
  const location = useLocation();
  useUtmTracking({ createLead: true });

  useEffect(() => {
    try {
      captureAttribution(window.location);
    } catch (error) {
      // La atribución nunca debe afectar la navegación.
    }
  }, [location.search]);

  return null;
};

export default AttributionTracker;
